import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tagExpand",
  "use": "icon-tagExpand-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tagExpand\">\n            <path d=\"M8.48532 5.6038C8.74532 5.80395 8.74532 6.19605 8.48532 6.3962L4.18 9.71044C3.85121 9.96354 3.375 9.72916 3.375 9.31424L3.375 2.68576C3.375 2.27084 3.85121 2.03646 4.18 2.28956L8.48532 5.6038Z\" fill=\"currentColor\" />\n          </symbol>"
});
var result = sprite.add(symbol);
export default symbol